import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

export const ModalImg = styled.img`
  max-width: 100%;
  max-height: 500px;
`;
